import { Action } from 'redux';
// Import States.
import {
	AppState,
	PolicyState,
} from '@app/redux/states';
// Import Actions.
import {
	LoadPolicyNotesAction,
	LoadPolicyNoteAction,
	SelectPolicyNoteAction,
	UnselectPolicyNoteAction,
} from '@app/redux/actions';
// Import state initializers.
import {
	initializePolicyState
} from '@app/redux/reducers/initializers';
// Import state queries.
import {
	queryPolicyState,
} from '@app/redux/reducers/queries';
// Import api models.
import {
	PolicyNoteRecord
} from '@app/models/api';


// Load Policy Notes Reducer.

let LoadPolicyNotesReducer = (state: AppState, action: Action): AppState => {
	let loadPolicyNotesAction: LoadPolicyNotesAction = action as LoadPolicyNotesAction;
	let policyNotes: PolicyNoteRecord[] = loadPolicyNotesAction.policyNotes;

	// Create copy of the of app state.
	let newState: AppState = initializePolicyState(state, loadPolicyNotesAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, loadPolicyNotesAction);

	policyState.policyNotes = policyNotes;
	policyState.arePolicyNotesLoaded = true;

	return newState;
}


// Load Policy Note Reducer.

let LoadPolicyNoteReducer = (state: AppState, action: Action): AppState => {
	let loadPolicyNoteAction: LoadPolicyNoteAction = action as LoadPolicyNoteAction;
	let loadedPolicyNote: PolicyNoteRecord = loadPolicyNoteAction.policyNote;

	// Create copy of the of app state.
	let newState: AppState = initializePolicyState(state, loadPolicyNoteAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, loadPolicyNoteAction);

	// Create shallow copy of the policy notes.
	policyState.policyNotes = [...policyState.policyNotes];
	// Get matching policy note.
	let matchingIndex: number = policyState.policyNotes.findIndex((policyNote: PolicyNoteRecord) => {
		return policyNote.id !== null && loadedPolicyNote.id !== null && policyNote.id === loadedPolicyNote.id;
	});

	if (matchingIndex === -1) {
		// Add policy note if it doesn't exist.
		policyState.policyNotes.push(loadedPolicyNote);
	}
	else {
		// Update policy note if it does exist.
		policyState.policyNotes[matchingIndex] = loadedPolicyNote;
	}

	return newState;
}


// Select Policy Note Reducer.

let SelectPolicyNoteReducer = (state: AppState, action: Action): AppState => {
	let selectPolicyNoteAction: SelectPolicyNoteAction = action as SelectPolicyNoteAction;
	let selectedPolicyNoteId: number = selectPolicyNoteAction.policyNoteId;

	// Create copy of the of app state.
	let newState: AppState = initializePolicyState(state, selectPolicyNoteAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, selectPolicyNoteAction);

	// Set selected policy note id.
	policyState.selectedPolicyNoteId = selectedPolicyNoteId;

	return newState;
}


// Unselect Policy Note Reducer.

let UnselectPolicyNoteReducer = (state: AppState, action: Action): AppState => {
	let unselectPolicyNoteAction: UnselectPolicyNoteAction = action as UnselectPolicyNoteAction;

	// Create copy of the of app state.
	let newState: AppState = initializePolicyState(state, unselectPolicyNoteAction);

	// Query the state.
	let policyState: PolicyState = queryPolicyState(newState, unselectPolicyNoteAction);

	// Remove any selected policy note id..
	policyState.selectedPolicyNoteId = undefined;

	return newState;
}

// Export reducers.
export {
	LoadPolicyNotesReducer,
	LoadPolicyNoteReducer,
	SelectPolicyNoteReducer,
	UnselectPolicyNoteReducer,
};